export default "__VITE_ASSET__BeQQdait__"